import { BaseLayout, type NavSection } from './BaseLayout';
import {
  LayoutDashboard, Building2, MapPin, Users, GraduationCap,
  User, Megaphone,
} from 'lucide-react';
import { useProfileBrandColor } from '../../theme/useProfileBrandColor';
import { useAuthStore } from '../../store/authStore';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

/**
 * Layout dedicado para Gestores Estaduais.
 * Sidebar com visão do estado: municípios, escolas, operacional.
 */
const ESTADUAL_SECTIONS: NavSection[] = [
  {
    title: null,
    items: [
      { to: '/estadual/dashboard', label: 'Dashboard', icon: LayoutDashboard },
      { to: '/estadual/ead', label: 'Video Aulas', icon: GraduationCap },
    ],
  },
  {
    title: 'Visao Estadual',
    items: [
      { to: '/estadual/municipios', label: 'Municipios', icon: MapPin },
      { to: '/estadual/escolas', label: 'Escolas', icon: Building2 },
    ],
  },
  {
    title: 'Gestao',
    items: [
      { to: '/estadual/usuarios', label: 'Usuarios', icon: Users },
    ],
  },
  {
    title: 'Minha Conta',
    items: [
      { to: '/estadual/perfil', label: 'Meu Perfil', icon: User },
      { to: '/estadual/alertas', label: 'Meus Comunicados', icon: Megaphone },
    ],
  },
];

export function EstadualLayout() {
  const { brandColor, brandGradient } = useProfileBrandColor('ESTADUAL');
  const user = useAuthStore((s) => s.user);
  const estadoId = user?.estadoId;

  const { data } = useQuery<{ estado?: { nome: string; sigla: string } }>({
    queryKey: ['estado-info', estadoId],
    queryFn: async () => {
      if (!estadoId) return { estado: undefined };
      const res = await api.get(`/estados/${estadoId}/dashboard`);
      return res.data;
    },
    enabled: Boolean(estadoId),
    staleTime: 1000 * 60 * 15,
  });

  const estadoNome = data?.estado?.nome || user?.preferencias?.estadoNome || 'Gestão da Rede';

  return (
    <BaseLayout
      sections={ESTADUAL_SECTIONS}
      headerTitle="Painel Estadual"
      brandLabel="ESTADUAL"
      brandSubtitle={estadoNome}
      brandColor={brandColor}
      brandGradient={brandGradient}
    />
  );
}
